// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-message-box__message {\n  max-height: 400px;\n}\n.el-message-box__message p {\n    max-height: 380px;\n    overflow: auto;\n}\n.thailand-export .cargo-rich-textarea.quill-editor .ql-container .ql-editor p {\n  line-height: 22px;\n}\n", ""]);
// Exports
module.exports = exports;
